module.exports = __webpack_public_path__ + "img/참고자료.c1b07f6c.svg";